import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ArrowDown from '@core/react/partner-filters/assets/svg/arrowDown';
import { isDesktopDevice } from '@core/components/utility';

/**
 * Reusable Single Accordion Component
 * @param {Object} props
 * @param {String} props.header - Accordion Header
 * @param {String} props.content - Accordion Content
 * @returns {JSX.Element}
 */
function SingleAccordion({ header, content, openAccordionToggle }) {
	const [isOpen, setIsOpen] = useState(openAccordionToggle ?? isDesktopDevice());

	const toggleAccordion = () => {
		setIsOpen(!isOpen);
	};

	return (
		<div className='accordion'>
			<div
				className={`accordion__header d-flex align-items-center justify-content-between info ${
					isOpen ? 'opened' : 'closed'
				}`}
				onClick={toggleAccordion}
				role='button'
				tabIndex={0}
				onKeyDown={(e) => {
					if (e.code === 'Enter') toggleAccordion();
				}}
			>
				<h5 className='h5 m-0 mb-4'>{header}</h5>

				<ArrowDown />
			</div>
			<div className={`accordion__content ${isOpen ? 'opened' : 'closed'}`}>
				{content}
			</div>
		</div>
	);
}

SingleAccordion.propTypes = {
	header: PropTypes.node.isRequired,
	content: PropTypes.node.isRequired,
	openAccordionToggle: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
};

export default SingleAccordion;
